<template>
    <div>
        this is index
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>